<template>
  <div v-if="loaded" class="print-main">
    <div class="print-left" :style="{ height: `${this.$util.getViewHeight() - 36 - 162}px` }">
      <div id="print-content" :class="{ 'print-content': true, 'set-black': !isSetColor }">
        <!-- title -->
        <div class="title-box">
          <h1 class="title-main">{{ $constant.company_info.company_name }}</h1>
          <div class="m-t-5">联系地址：{{ $constant.company_info.company_address }}</div>
          <div class="m-t-5">联系电话：{{ $constant.company_info.company_phone }}</div>
          <h2 class="title-sub">
            <span>制造流程</span>
            <span class="title-number">
              <span>NO.</span>
              <span class="title-red">{{ detailData.formData.bill_code }}</span>
              <span>{{ goodsStr }}</span>
            </span>
          </h2>
        </div>

        <!-- formData -->
        <div class="form-main">
          <div class="form-list" v-for="(itemSt, indexSt) in formData" :key="indexSt">
            <div
              :class="{ 'form-item': true, 'flex-sub': indexNd === 2 }"
              v-for="(itemNd, indexNd) in itemSt"
              :key="indexNd"
            >
              <div class="form-key">{{ itemNd.key }}{{ itemNd.key && '：' }}</div>
              <div class="form-val" v-if="itemNd.val">
                <span v-if="itemNd.val === 'bill_date' || itemNd.val === 'jiao_huo_ri_qi'">
                  {{
                    detailData.formData[itemNd.val]
                      ? detailData.formData[itemNd.val].slice(0, 10)
                      : '&nbsp;'
                  }}
                </span>
                <span v-else>
                  {{ detailData.formData[itemNd.val] || '&nbsp;' }}
                </span>
                <span
                  v-if="itemNd.val === 'company_id' && detailData.formData.customer_rating"
                  class="c-red"
                  >({{ detailData.formData.customer_rating }})</span
                >
              </div>
            </div>
          </div>
        </div>

        <!-- tableData -->
        <div class="table-main">
          <PrintTable :data="[detailData.tableSaleData[goodsIndex]]" />
        </div>

        <div>
          <div>
            <div class="flex l-h-half f-bold m-b-10">
              <div class="flex-1">名称</div>
              <div class="flex-1">规格</div>
              <div class="flex-1">数量</div>
              <div class="flex-1">单价</div>
              <div class="flex-1">金额</div>
            </div>
            <div v-for="(item, index) in zhizaoData.table_1" :key="index" class="flex l-h-half">
              <span class="flex-1">
                <span>原料{{ index + 1 }}：</span>
                <span>{{ item.name }}</span>
              </span>
              <span class="flex-1">{{ item.spec }}</span>
              <span class="flex-1">
                {{ item.counts }}
                {{ item.unit }}
              </span>
              <span class="flex-1">{{ item.goods_price }}元/{{ item.unit }}</span>
              <span class="flex-1">合计：{{ item.goods_amount }}元</span>
            </div>
          </div>

          <div v-for="(itemSt, indexSt) in zhizaoData.table_3" :key="indexSt" class="m-t-5">
            <hr />
            <div v-for="(itemNd, indexNd) in itemSt.list" :key="indexNd" class="flex l-h-half">
              <span class="flex-1">
                <span>{{ itemNd.seq }}：</span>
                <span>{{ itemNd.name }}</span>
              </span>
              <span class="flex-1">{{ itemNd.spec }}</span>
              <span class="flex-1">
                {{ itemNd.counts }}
                {{ itemNd.unit }}
              </span>
              <span class="flex-1">{{ itemNd.goods_price }}元/{{ itemNd.unit }}</span>
              <span class="flex-1">合计：{{ itemNd.goods_amount }}元</span>
            </div>
          </div>

          <div class="m-t-5" v-if="zhizaoData.table_4.length">
            <hr />
            <div v-for="(item, index) in zhizaoData.table_4" :key="index" class="flex l-h-half">
              <span class="flex-1">
                <span>费用{{ index + 1 }}：</span>
                <span>{{ item.name }}</span>
              </span>
              <span class="flex-1">{{ item.spec }}</span>
              <span class="flex-1">
                {{ item.counts }}
                {{ item.unit }}
              </span>
              <span class="flex-1">{{ item.goods_price }}元/{{ item.unit }}</span>
              <span class="flex-1">合计：{{ item.goods_amount }}元</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="print-right">
      <div class="print-do">
        <div>
          <div v-for="(item, index) in detailData.tableSaleData" :key="index" class="flex m-b-10">
            <el-button
              class="flex-1 ellipsis"
              type="success"
              size="small"
              @click="toggleActive(index)"
              :title="item.name"
              :plain="goodsIndex !== index"
              >{{ item.name }}</el-button
            >
          </div>
          <el-checkbox class="m-b-10" v-model="isSetColor">打印为彩色</el-checkbox>
          <el-button
            ref="printBtn"
            class="print-btn"
            v-print="printData"
            type="primary"
            size="small"
          >
            打印
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrintTable: () => import('./print-table')
  },
  data() {
    return {
      loaded: false,
      isSetColor: false,
      detailData: {},
      printData: {
        id: 'print-content',
        popTitle: '&nbsp;'
      },
      formData: [
        [
          {
            key: '销售单号',
            val: 'bill_code'
          },
          {
            key: '订单类型',
            val: 'ding_dan_lei_xing'
          },
          {
            key: '客户',
            val: 'company_id'
          }
        ],
        [
          {
            key: '销售日期',
            val: 'bill_date'
          },
          {
            key: '业务员',
            val: 'saler_name'
          },
          {
            key: '交货日期',
            val: 'jiao_huo_ri_qi'
          }
        ]
      ],
      zhizaoData: {},
      goodsIndex: 0
    }
  },
  computed: {
    billId() {
      return this.$route.query.billId
    },
    goodsId() {
      return this.$route.query.goodsId
    },
    goodsStr() {
      let result = `(${this.goodsIndex + 1}/${this.detailData.tableSaleData.length})`
      return result
    }
  },
  watch: {
    goodsIndex() {
      this.getZhizaoDetailData()
    }
  },
  mounted() {
    this.getDetailData()
  },
  methods: {
    // 获取详情数据
    async getDetailData() {
      this.loaded = false
      let url = '/admin/gcvip/gongChengXieTong3/detail'
      await this.$api({
        method: 'get',
        url,
        params: {
          id: this.billId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data)
          this.detailData = result
          this.goodsIndex = this.detailData.tableSaleData.findIndex((item) => {
            return item.id === Number(this.goodsId)
          })
          this.getZhizaoDetailData()
          // setTimeout(() => {
          //   this.printPrint()
          // }, 100)
        }
      })
      this.loaded = true
    },

    // 获取制造详情数据
    async getZhizaoDetailData() {
      await this.$api({
        method: 'get',
        url: '/admin/gcvip/gongChengXieTong3/zhizaoOneDetail',
        params: {
          id: this.billId,
          stockId: this.detailData.tableSaleData[this.goodsIndex].id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data)
          let table_1 = result.table_1.filter((item) => !item.has_bom)
          result.table_1 = this.$util.deepCopy(table_1)
          this.zhizaoData = result
        }
      })
      this.loaded = true
    },
    // 切换 active 类
    toggleActive(index) {
      this.goodsIndex = index
    }
    // ,
    // 自动触发打印按钮
    // printPrint() {
    //   this.$refs.printBtn.$el.click()
    // }
  }
}
</script>

<style lang="less" scoped>
// print
.print-main {
  display: flex;
  background: #f5f7fa;
  .print-left {
    margin: 10px;
    padding: 20px;
    width: 712px;
    background: #fff;
    overflow-y: auto;
    .scroll-bar();
  }
  .print-right {
    margin: 10px 10px 10px 0;
    padding: 10px;
    width: 200px;
    background: #fff;
    .print-btn {
      width: 100%;
    }
    .print-do {
      margin-bottom: 20px;
      padding: 20px;
      text-align: center;
      font-size: 14px;
      background: #f8f8f8;
    }
  }
}

// content
.print-content {
  font-size: 12px;
  line-height: 1.5;
  font-family: 'Arial,Microsoft YaHei,SimHei,SimSun';
  overflow: hidden;
  &.set-black {
    ::v-deep * {
      color: @colorBlack !important;
      background: @colorWhite !important;
    }
    ::v-deep .print-table .step-line {
      border-top-style: solid !important;
    }
    ::v-deep .print-table .view-main * {
      border-color: @colorBlack !important;
    }
  }
}

// title
.title-box {
  margin: 10px 0 30px 0;
  text-align: center;
}
.title-main {
  margin: 0;
  font-size: 24px;
}
.title-sub {
  position: relative;
  margin: 20px 0 0 0;
  font-size: 20px;
}
.title-number {
  position: absolute;
  top: 0;
  right: 0;
}
.title-red {
  color: #cf2438;
}

// form
.form-main {
  display: flex;
  margin-top: 20px;
}
.form-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  & ~ .form-list {
    margin-left: 10px;
  }
  .form-item {
    flex: 1;
    display: flex;
    align-items: center;
    &.form-st {
      font-weight: bold;
    }
    .form-key {
      border-bottom: 1px solid #fff;
    }
    .form-val {
      flex: 1;
      padding: 2px 0;
      border-bottom: 1px solid #000;
    }
  }
}

// table
.table-main {
  margin: 20px 0;
}
</style>
